'use client';

import { useState, useRef } from 'react';
import { UploadIcon, XIcon, SendIcon } from './chatbot-icons';
import { ChatInputProps } from './models';
import { CHATBOT_TEXT } from './text';

export function ChatInput({ onSendMessage, isLoading = false }: ChatInputProps) {
    const [message, setMessage] = useState('');
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [isSending, setIsSending] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!message.trim() || isLoading || isSending) return;

        setIsSending(true);
        try {
            await onSendMessage(message, selectedFile || undefined);
            setMessage('');
            setSelectedFile(null);
        } finally {
            setIsSending(false);
        }
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            setSelectedFile(file);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="border-t border-gray-100 p-4 bg-white">
                {selectedFile && (
                    <div className="mb-3 flex items-center gap-2 bg-gradient-to-r from-blue-50 to-cyan-50 border border-[#05a6f0]/20 p-3 rounded-lg">
                        <UploadIcon className="w-4 h-4 text-[#05a6f0] flex-shrink-0" />
                        <span className="text-sm text-gray-700 truncate flex-1 font-medium">{selectedFile.name}</span>
                        <button
                            type="button"
                            onClick={() => setSelectedFile(null)}
                            className="p-1 hover:bg-gray-200 rounded transition-colors"
                        >
                            <XIcon className="w-4 h-4 text-gray-500" />
                        </button>
                    </div>
                )}

                <div className="flex gap-2 items-center">
                    {/* <button
                        type="button"
                        onClick={() => fileInputRef.current?.click()}
                        disabled={isLoading || isSending}
                        className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors disabled:opacity-50 text-gray-600"
                        aria-label="Attach file"
                        title="Upload document or file"
                    >
                        <PaperclipIcon className="w-5 h-5" />
                    </button> */}

                    <input ref={fileInputRef} type="file" onChange={handleFileChange} className="hidden" accept="*/*" />

                    <input
                        type="text"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        placeholder={CHATBOT_TEXT.inputPlaceholder}
                        className="flex-1 px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#05a6f0]/50 focus:border-[#05a6f0] text-gray-900 placeholder-gray-400 disabled:opacity-50 font-medium text-sm"
                    />

                    <button
                        type="submit"
                        disabled={!message.trim() || isLoading || isSending}
                        className="p-2.5 bg-[#08A6F0] hover:shadow-lg text-white rounded-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                        aria-label="Send message"
                    >
                        <SendIcon className="w-5 h-5" />
                    </button>
                </div>
        </form>
    );
}
